import { Widgets } from '@tock/shared/types/widget';
import { useCreateNamedConfigurations } from '../widgetFormUtils';
import MarketingFeatureNamedConfigurationForm, {
  MarketingFeatureFormFields,
  emptyMfw,
} from 'components/consumer-page-widgets/marketing-feature-widget/MarketingFeatureNamedConfigurationForm';

interface Props {
  onCompleteOrCancel(): void;
}

const CreateMarketingFeatureWidgetForm: React.FunctionComponent<React.PropsWithChildren<Props>> = ({
  onCompleteOrCancel,
}) => {
  const createNamedConfig = useCreateNamedConfigurations();

  const handleSubmit = ({ name, tiles }: MarketingFeatureFormFields) => {
    return createNamedConfig({
      name,
      widgetType: Widgets.WidgetCreatorWidgetType,
      marketingFeaturesWidgetConfig: { tile: tiles },
    }).then(onCompleteOrCancel);
  };

  return (
    <MarketingFeatureNamedConfigurationForm
      initialValues={emptyMfw}
      onSubmit={handleSubmit}
      // idk if this is the right functionality
      onClear={onCompleteOrCancel}
    />
  );
};

export default CreateMarketingFeatureWidgetForm;
